import React from 'react';
import IOSSwitch from "./iOSswitch";
import styles from './ADSKeepStructure.module.scss'

const ADSKeepStructure = ({checked, onChange, disabled}) => {
  return (
    <div className={styles.wrapper}>
      <IOSSwitch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />

      <p style={{color: disabled ? '#1D1B201A' : 'auto'}}>Keep the structure of the selected image</p>
    </div>
  );
};

export default ADSKeepStructure;
